// Libraries
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
// Components
import { initialState } from './datePickerStore.state';
import { datePickerActions } from './datePickerStore.actions';
// Types
import { DatePickerStore } from './datePickerStore.types';

/**
 * Creates and configures the Date picker store.
 */
export const useDatePickerStore = create(
  immer<DatePickerStore>((set) => ({
    ...initialState,
    ...datePickerActions(set),
  }))
);
